import Error from "./error";

export { Error };
export default Error;
